// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verQ3LSj9rExfx6MxH3H{border:1px solid var(--border-neutral-default);border-radius:6px}.verQ3LSj9rExfx6MxH3H .__TjLpr7uQj3eYn8vwmY{background:0 0;min-height:38px;padding:11px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionsWrap": `verQ3LSj9rExfx6MxH3H`,
	"option": `__TjLpr7uQj3eYn8vwmY`
};
export default ___CSS_LOADER_EXPORT___;
